export default __webpack_public_path__ + "static/media/add.a020d92e.png";